export function getValue(obj, path) {

    if (!path)
        return null;

    return path
        .replace(/\[(\d+)\]/g, '.$1')
        .split('.')
        .reduce(
            (o, key) => o?.[key],
            obj
        );
}

export function setValue(obj, path, value) {

    const keys = path
        .replace(/\[(\d+)\]/g, '.$1')
        .split('.');

    let current = obj;

    for (let i = 0; i < keys.length - 1; i++) {

        current = current?.[keys[i]];

        if (current == null)
            return;

    }

    current[keys[keys.length - 1]] = value;
}